/**
 * 요양병원/호스피스 상세 방문 기록.
 *
 * 기록은 ssr-platform(care/hospice 상세), 조회는 platform(시설 상세)에서 한다.
 * 두 앱은 platform/middleware.ts 의 catch-all rewrite 로 같은 오리진
 * (www.goifuneral.co.kr)에서 서빙되므로 localStorage 가 공유된다.
 * 쿠키를 쓰면 quotation_request 처럼 root-domain 충돌 위험이 생기므로 쓰지 않는다.
 *
 * 유효기간 없음. "경로에 포함되면 매번" 이라는 스레드 결정을 문자 그대로 따른다.
 * 지금은 노출 이벤트로 실제 방문 간격 분포를 보는 게 먼저다.
 *
 * 상세는 wiki/features/care-facility-lead-modal.md 참고.
 */
export type CareVisitType = "care" | "hospice";

const CARE_VISIT_STORAGE_KEY = "goi_care_visit_type";

/** 요양병원/호스피스를 나중에 다시 봐도 마지막 방문 유형으로 덮어쓴다. */
export function markCareVisit(type: CareVisitType) {
  try {
    localStorage.setItem(CARE_VISIT_STORAGE_KEY, type);
  } catch {
    // localStorage 접근 불가(시크릿 모드 등) - 무시
  }
}

/** 방문 기록이 없거나 읽을 수 없으면 null. 호출부는 조용히 미노출로 처리한다. */
export function getCareVisitType(): CareVisitType | null {
  try {
    const raw = localStorage.getItem(CARE_VISIT_STORAGE_KEY);
    return raw === "care" || raw === "hospice" ? raw : null;
  } catch {
    return null;
  }
}

export const CARE_VISIT_LABEL: Record<CareVisitType, string> = {
  care: "요양병원",
  hospice: "호스피스",
};
